import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Badge,
  Card,
  CardHeader,
  CardBody,
  Divider,
  Icon,
  Button,
  SimpleGrid,
} from '@chakra-ui/react';
import { CheckCircleIcon, InfoOutlineIcon, ArrowRightIcon } from '@chakra-ui/icons';

const FqDemoWrapCompliance = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading size="lg" color="brand.700" mb={2}>Wrap-Around Compliance Check</Heading>
          <Text color="gray.600">
            Detecting missed Medicare Advantage to Medi-Cal wrap opportunities and ensuring strict modifier compliance.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
          {/* Left Column: The Scenario */}
          <VStack align="stretch" spacing={6}>
            <Card variant="outline" bg="white" borderColor="red.200">
              <CardHeader bg="red.50" pb={2}>
                <HStack justify="space-between">
                  <HStack>
                    <Icon as={InfoOutlineIcon} color="red.500" />
                    <Heading size="sm" color="red.700">Missed Revenue Detected</Heading>
                  </HStack>
                  <Badge colorScheme="red">Action Required</Badge>
                </HStack>
              </CardHeader>
              <CardBody>
                <VStack align="stretch" spacing={4}>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm" color="gray.500">Patient</Text>
                    <Text>David Kim (DOB: 04/12/1955)</Text>
                  </Box>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm" color="gray.500">Primary Payer (Medicare Advantage)</Text>
                    <Text>Paid: $85.00 (Contracted Rate)</Text>
                  </Box>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm" color="gray.500">FQHC PPS Rate</Text>
                    <Text>$245.00</Text>
                  </Box>
                  <Divider />
                  <HStack justify="space-between">
                    <Text fontWeight="bold" color="red.600">Missed Wrap Opportunity</Text>
                    <Text fontWeight="bold" color="red.600">$160.00</Text>
                  </HStack>
                </VStack>
              </CardBody>
            </Card>

            <Card variant="outline" bg="blue.50" borderColor="blue.200">
              <CardBody>
                <HStack align="start">
                  <Icon as={InfoOutlineIcon} color="blue.500" mt={1} />
                  <Box>
                    <Text fontWeight="bold" color="blue.800" mb={2}>Medi-Cal Rule Citation</Text>
                    <Text fontSize="sm" color="blue.700" fontStyle="italic">
                      "When an FQHC provides a covered service to a Medi-Cal beneficiary who is also enrolled in a Medicare Advantage plan, the FQHC is entitled to a wrap-around payment equal to the difference between their PPS rate and the Medicare Advantage payment. This must be billed using Revenue Code 0521 and HCPCS code T1015 with the SE modifier."
                    </Text>
                    <Text fontSize="xs" color="blue.600" mt={2}>
                      Source: Medi-Cal Provider Manual: Rural Health Clinics (RHCs) and FQHCs
                    </Text>
                  </Box>
                </HStack>
              </CardBody>
            </Card>
          </VStack>

          {/* Right Column: The Revedy Solution */}
          <Card variant="outline" bg="white" borderColor="green.200">
            <CardHeader bg="green.50" pb={2}>
              <HStack justify="space-between">
                <HStack>
                  <Icon as={CheckCircleIcon} color="green.500" />
                  <Heading size="sm" color="green.700">Revedy Auto-Drafted Claim</Heading>
                </HStack>
                <Badge colorScheme="green">Ready to Submit</Badge>
              </HStack>
            </CardHeader>
            <CardBody>
              <VStack align="stretch" spacing={6}>
                <Text fontSize="sm" color="gray.600">
                  Revedy has automatically generated the secondary wrap claim to Medi-Cal, applying the correct revenue codes and modifiers based on the cited rule.
                </Text>

                <Box borderWidth="1px" borderRadius="md" p={4} bg="gray.50">
                  <VStack align="stretch" spacing={3}>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Revenue Code</Text>
                      <Badge colorScheme="purple">0521 (Clinic Visit)</Badge>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">HCPCS Code</Text>
                      <Badge colorScheme="blue">T1015</Badge>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Modifier 1</Text>
                      <Badge colorScheme="orange">SE (State/Federal Funded)</Badge>
                    </HStack>
                    <Divider />
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Prior Payments (EOB)</Text>
                      <Text fontSize="sm">$85.00</Text>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Billed Amount</Text>
                      <Text fontSize="sm" fontWeight="bold" color="green.600">$160.00</Text>
                    </HStack>
                  </VStack>
                </Box>

                <Button colorScheme="green" size="lg" rightIcon={<ArrowRightIcon />}>
                  Approve & Submit Wrap Claim
                </Button>
              </VStack>
            </CardBody>
          </Card>
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default FqDemoWrapCompliance;
